import { combineReducers } from "@reduxjs/toolkit";
import layoutReducer from "./slices/layout-slice";
import authReducer from "./slices/auth-slice";
import endorsementsReducer from "./slices/endorsement.slice";
import usersReducer from "./slices/user.slice";
import studentInstructorReducer from "./slices/instructor-student.slice";
import invitationReducer from "./slices/invitation.slice";
import requestSignatureReducer from "./slices/request-signature.slice";
import notificationReducer from "./slices/notification.slice";

const rootReducer = combineReducers({
  layout: layoutReducer,
  auth: authReducer,
  user: usersReducer,
  endorsement: endorsementsReducer,
  studentInstructor: studentInstructorReducer,
  invitation: invitationReducer,
  requestSignature: requestSignatureReducer,
  notification: notificationReducer,
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
